import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from '../CommerceWizard.styles';
import { ToolTipFixedWidth } from 'components/common/tooltips';

const maxTextLength = 150;

const CWProduct = (props) => {
  const [expanded, setExpanded] = useState(false);

  const getProductDescription = () => {
    const { description } = props;
    if (description && description.length > maxTextLength) {
      return expanded ? description : `${description.slice(0, maxTextLength)}...`;
    }

    return description;
  };

  const seeMoreNeeded = () => {
    const { description } = props;

    return !!description && description.length > maxTextLength;
  };

  const showLink = () => {
    if (!props.productLink) {
      return false;
    }

    return seeMoreNeeded() ? expanded : true;
  };

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      <S.SectionLabel>
        {props.headerText}{' '}
        {props.tooltipText ? (
          <ToolTipFixedWidth arrow placement="bottom" content={props.tooltipText}>
            <img src={'/images/tooltip-icon.svg'} alt="icon" />
          </ToolTipFixedWidth>
        ) : (
          <img src={'/images/commerce/similar-product-icon.svg'} alt="icon" />
        )}
      </S.SectionLabel>
      <S.CustomerProduct seeMorePresent={seeMoreNeeded()}>
        <S.CustomerProductImage url={props.image} />
        <h1>{props.title}</h1>
        {props.price && (
          <h4>
            Price: <span>${props.price}</span>
          </h4>
        )}
        <p>{getProductDescription()}</p>
        {showLink() && (
          <a href={props.productLink} target="_blank" rel="noopener noreferrer">
            Link to product page
          </a>
        )}
        {seeMoreNeeded() && (
          <S.ExpandLink onClick={() => handleExpandClick()}>
            {expanded ? 'READ LESS' : 'READ MORE'}
            <img src={`/images/arrows/${expanded ? 'up' : 'down'}-arrow-gray.svg`} alt={'arrow'} />
          </S.ExpandLink>
        )}
      </S.CustomerProduct>
    </>
  );
};

CWProduct.propTypes = {
  headerText: PropTypes.string.isRequired,
  image: PropTypes.string,
  productLink: PropTypes.string,
  description: PropTypes.string.isRequired,
  price: PropTypes.string,
  title: PropTypes.string.isRequired,
};

export default CWProduct;
